// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2DbTt","buttons":"Footer_buttons__3jUk5"};